module.exports = __webpack_public_path__ + "img/palette-3-fg_en.e6d0fa2.jpg";